define(function(require) {
  var IpsModel = require('civicsBase/ipsModel');
  return IpsModel.extend({
    validation:{
      type:{
        code:{
          required:true
        }
      },
      method:{
        code:{
          required:true
        }
      },
      details:{
        required:false
      }
    },
    urlRoot: '/delegate/civics-api/api/resources/notifications',
    url: function(){
      if ( this.isNew()){
          return '/delegate/civics-api/api/resources/contactidentities/'+ this.get('contactIdentityId') + '/notifications';
      }
      else {
        return Backbone.Model.prototype.url.apply(this);
      }
    },
    parse:function(r){
        if( r.data.method && r.data.method.code && r.data.method.code.trim().length > 0 ){
          if( r.data.method.description == null || r.data.method.description.trim().length == 0 ){
            r.data.method.description = i18n.t('CIVICS.COMMON.VALUE_NOT_CONFIG');
          }
        }

        if( r.data.type && r.data.type.code && r.data.type.code.trim().length > 0 ){
          if( r.data.type.description == null || r.data.type.description.trim().length == 0 ){
            r.data.type.description = i18n.t('CIVICS.COMMON.VALUE_NOT_CONFIG');
          }
        }

      return r.data;
    }
  });
});
